define('app/dashboard/dialogs/CreateMonitorDialogView',['require','glu/itemView','app/models/Report','glu/$','app/app','hbs!./CreateMonitorDialogView.hbs','glu/fileupload'],function(require) {
	'use strict';

	var ItemView = require('glu/itemView'),
		Report = require('app/models/Report'),
		$ = require('glu/$'),
		APP = require('app/app');

	var view = ItemView.extend({

		template: require('hbs!./CreateMonitorDialogView.hbs'),

		fileupload: require('glu/fileupload'),

		dialogTitle: 'Create a monitor',

		getClass: function() {
			return 'modal-create-report';
		},

		dialogButtons: [{
			text: 'Create monitor',
			callback: 'select',
			className: 'btn-primary disabled'
		}],

		ui: {
			$selectedDomain: '[name="domain"]',
			$selectedFile: '[name="import-report"]',
			$reportMode: '[name="report-type"]'
		},

		events: {
			'change [name="domain"]': 'changeDomain',
			'change [name="report-type"]': 'updateMode'
		},

		initialize: function() {
			this.createReportMode = true;

			// Create a file reader
			if (window.File && window.FileReader && window.FileList && window.Blob) {
				this.reader = new FileReader();
				return true;
			}
		},

		changeDomain: function() {
			if ($(this.ui.$selectedDomain).val() && $(this.ui.$selectedDomain).val() !== '') {
				$('.modal-create-report .modal-footer .btn-primary').removeClass('disabled');
			} else {
				$('.modal-create-report .modal-footer .btn-primary').addClass('disabled');
			}
		},

		updateMode: function(e) {
			if ($(e.target).val() === 'create-report') {
				this.createReportMode = true;
				$('.modal-create-report .modal-footer .btn-primary').text('Create report');

				if ($(this.ui.$selectedDomain).val() && $(this.ui.$selectedDomain).val() !== '') {
					$('.modal-create-report .modal-footer .btn-primary').removeClass('disabled');
				} else {
					$('.modal-create-report .modal-footer .btn-primary').addClass('disabled');
				}
				this.render();
			} else {
				this.createReportMode = false;
				$('.modal-create-report .modal-footer .btn-primary').text('Import report from file');

				if (this.selectedFile && this.selectedFile !== '') {
					$('.modal-create-report .modal-footer .btn-primary').removeClass('disabled');
				} else {
					$('.modal-create-report .modal-footer .btn-primary').addClass('disabled');
				}
				this.render();
			}
		},

		isCreateReport: function() {
			return this.createReportMode;
		},

		selectableOptions: function() {
			var domains = APP.domains;

			return domains.map(function(domain) {
				return {
					value: domain.get('id'),
					label: domain.get('name')
				};
			});
		},

		getIEVersion: function() {
			var sAgent = window.navigator.userAgent;
			var Idx = sAgent.indexOf('MSIE');

			if (Idx > 0) {
				return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf('.', Idx)), 10);
			} else if (navigator.userAgent.match(/Trident\/7\./)) {
				return 11;
			} else {
				return 0;
			}
		},

		onRender: function() {
			var self = this;

			this.isIE = this.getIEVersion() > 0;

			if (this.selectableOptions().length === 1) {
				this.ui.$selectedDomain.val(this.selectableOptions()[0].value);
			}

			this.$el.find(this.ui.$selectedDomain).val('');

			// Create combobox
			this.ui.$selectedDomain.comboBox({
				placeholder: 'Select a domain'
			});

			// Create file uploader
			var uploaderOptions = {
				type: 'POST',
				autoUpload: false,
				dataType: 'text', // caters for empty response body
				dropZone: '.file-upload .dropzone',
				pasteZone: '.file-upload .dropzone',
				paramName: 'contentData',
				sequentialUploads: false,
				maxNumberOfFiles: 1,
				url: '#',

				add: function(e, data) {
					self.uploadValidation = undefined;
					self.selectedFile = undefined;
					self.file = undefined;

					if (data.files[0] && data.files[0].type !== 'text/plain') {
						self.uploadValidation = 'Please select a valid export file.';
						self.render();
						$('.modal-create-report .modal-footer .btn-primary').addClass('disabled');
						return;
					} else {
						self.selectedFile = data.files[0].name;
						self.render();
						self.file = data.files[0];
						$('.modal-create-report .modal-footer .btn-primary').removeClass('disabled');
					}
				}
			};

			self.$(this.ui.$selectedFile).fileupload(uploaderOptions);

			self.$(self.ui.$selectedFile).bind('click', function(e) {
				e.stopPropagation();
			});
			self.$('div[data-hook="file-upload"]').on('click', function(e) {
				e.preventDefault();

				self.$(self.ui.$selectedFile).trigger('click');
			});

			// Toggle upload/create mode
			if (this.createReportMode) {
				$('input[value="create-report"]').prop('checked', true);
			} else {
				$('input[value="import-report"]').prop('checked', true);
			}
		},

		select: function() {
			if (this.createReportMode) {
				var domain = this.$el.find(this.ui.$selectedDomain).val();
				var dashboard = this.options.dashboardId;

				if (!domain || domain === '') {
					this.$el.find(this.ui.$selectedDomain).parent().addClass('has-error');
				} else {
					this.$el.find(this.ui.$selectedDomain).parent().removeClass('has-error');
					this.trigger('create-monitor', domain, dashboard);
				}
			} else {
				this.readText(this.file);
			}
		},

		serializeData: function() {
			return this;
		},

		validateReport: function(report) {
			var validationMessage = '';
			report.columns().some(function(c) {
				if (c.get('segmentId') && (APP.segments.length === 0 || !APP.segments.get(c.get('segmentId')))) {
					validationMessage = 'This report cannot be imported as it uses deleted or unavailable segments.';
					return true;
				}
			});
			return validationMessage;
		},

		readText: function(file) {
			var self = this,
				importObj = new Report();

			// Reset simple validation
			this.uploadValidation = undefined;

			if (file && file.type === 'text/plain') {
				self.reader.onload = function(e) {
					importObj.importJson(e.target.result).then(
						function success(res) {
							APP.segments.reset();
							APP.segments.fetch().then(function() {
								var report = new Report();
								report.set(report.parse(res));
								report.set('owner', APP.user.getUsername());

								// validate columns for segments
								var validationMessage = self.validateReport(report);
								if (!validationMessage) {
									// Flag the report as recent imported
									report.set('recentlyImported', true);

									APP.openReports.add(report);
									self.trigger('import-report', report);
								} else {
									self.uploadValidation = validationMessage;
									self.render();
								}
							});
						},
						function invalid() {
							self.uploadValidation = 'The file you selected was not a valid report export file. Please choose a different file, and try again.';
							self.render();
						});
				};
				self.reader.readAsText(file);
			} else {
				this.uploadValidation = 'Please select a valid export file.';
				this.render();
				return false;
			}
		}
	});

	return view;
});

